import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import PublicSecureAuthorization
    from "../../../../services/system/secure-authorization/secure-authorization-controller";
import {getSchoolYear, setSchoolYear, setSchoolYearName} from "../../../../utils/authority";
import OfficerController from "../../../../services/system/staff/officer-controller";
import DatePicker from "react-datepicker";
import ModalDeleteStaff from "./modalDeleteStaff";
import YearController from "../../../../services/data-declaration/year-controller";
import {toast} from "react-toastify";

class StaffManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            pageNumber: 0,
            pageSize: 10,
            page: 0,


            birthday: "",
            code: "",
            contract: '',
            degree: '',
            departmentId: -1,
            fullName: '',
            gender: '',
            job: '',
            jobState: '',

            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "fullName",
                    name: "Họ và tên",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã cán bộ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "birthday",
                    name: "Ngày sinh",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "gender",
                    name: "Giới tính",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "contract",
                    name: "Loại hợp đồng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "degree",
                    name: "Trình độ đào tạo",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    getDegree(degree){
        if (degree == "TRUNG_CAP"){
            return "Trung cấp";
        }else if (degree == "CAO_DANG"){
            return "Cao đẳng";
        }else if (degree == "DAI_HOC"){
            return "Đại học";
        }else if (degree == "THAC_SI"){
            return "Thạc sĩ";
        }else if (degree == "TIEN_SI"){
            return "Tiến sĩ";
        }else if (degree == "PGS_TIEN_SI"){
            return "PGS.Tiến sĩ";
        }else if (degree == "GIAO_SU"){
            return "Giáo sư";
        }
        return ""
    }
    componentDidMount() {
        this.setState({showLoading: true},
            () => this.getListStaff()
        )
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    // ---------------------------------------------------------------------------------------------------------
    getListYears = () => {
        let {pageNumber, pageSize} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            "sort": "created_at desc"
        };
        YearController.getListYear(payload, res => {
            if (res.success) {
                this.setState({
                    ListYear: res.data.content,
                    showLoading: false
                });
                if (res.data.content.length > 0 && getSchoolYear() === undefined){
                    setSchoolYear(res.data.content[0].id)
                    setSchoolYearName(res.data.content[0].year+"-"+(parseInt(res.data.content[0].year)+1))
                }
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };
    getListStaff() {
        if (getSchoolYear()===undefined){
            this.setState(
                {
                    showLoading: false
                }
            );
            toast.error("Vui lòng chọn năm học!")
        }else {
            let payload = {
                yearId: parseInt(getSchoolYear()),
                pageNumber: this.state.pageNumber,
                pageSize: this.state.pageSize,
            };
            OfficerController.getList(payload, res => {
                if (res.success) {
                    let data = res.data.content;
                    this.setState(
                        {
                            listData: res.data.content,
                            totalItem: res.data.totalElements,
                            totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                            showLoading: data.length < 0
                        }
                    );
                } else {
                }
            });
        }
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListStaff();
            }
        );
    };
    onhandleSearch(){
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            birthday: this.state.birthday,
            code: this.state.code,
            contract: this.state.contract,
            degree: this.state.degree,
            departmentId: parseInt(this.state.departmentId),
            fullName: this.state.fullName,
            gender: this.state.gender,
            job: this.state.job,
            jobState: this.state.jobState,
            "sort": "created_at desc"
        };
        OfficerController.search(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }
    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-staff" parentClass="staff-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý cán bộ"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tổ bộ môn</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.departmentId}
                                                    onChange={(e) => {
                                                        this.state.departmentId = e.target.value;
                                                        this.setState({
                                                            departmentId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Tất cả</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Công việc</label>
                                                <input
                                                    placeholder="Nhập công việc"
                                                    name="Code"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.job}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({job: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.jobState}
                                                    onChange={(e) => {
                                                        this.state.jobState = e.target.value;
                                                        this.setState({
                                                            jobState: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="WORKING">Đang làm việc</option>
                                                    <option value="STOP">Đã nghỉ</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Mã cán bộ</label>
                                                <input
                                                    placeholder="Nhập mã cán bộ"
                                                    name="Code"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.code}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({code: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Họ và tên</label>
                                                <input
                                                    placeholder="Nhập họ tên"
                                                    name=""
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.fullName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({fullName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Ngày sinh</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.birthday === '' ? null : new Date(this.state.birthday)}
                                                    maxDate={new Date()}
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    birthday: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Giới tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trình độ đào tạo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.degree}
                                                    onChange={(e) => {
                                                        this.state.degree = e.target.value;
                                                        this.setState({
                                                            degree: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="TRUNG_CAP">Trung cấp</option>
                                                    <option value="CAO_DANG">Cao đẳng</option>
                                                    <option value="DAI_HOC">Đại học</option>
                                                    <option value="THAC_SI">Thạc sĩ</option>
                                                    <option value="TIEN_SI">Tiến sĩ</option>
                                                    <option value="PGS_TIEN_SI">PGS.Tiến sĩ</option>
                                                    <option value="GIAO_SU">Giáo sư</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-4 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Loại hợp đồng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.contract}
                                                    onChange={(e) => {
                                                        this.state.contract = e.target.value;
                                                        this.setState({
                                                            contract: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="BIEN_CHE">Biên chế</option>
                                                    <option value="HOP_DONG">Hợp đồng</option>

                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    to="/ad-sas-school/them-moi-can-bo"
                                                >
                                                    <button
                                                        type="button"
                                                        className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                        title='Thêm mới'
                                                        style={{cursor: 'pointer'}}
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Xuất Excell
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.code}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.gender== "MALE"?"Nam": "Nữ"}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.contract== "BIEN_CHE"?"Biên chế": "Hợp đồng"}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {this.getDegree(row.degree)}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/chi-tiet-can-bo",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xem chi tiết'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-book"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/sua-can-bo",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteStaff
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default StaffManagement;
